import React from "react";
import TextareaAutosize from 'react-textarea-autosize';

type IProps = {
  type: string
  name: string
  value: string
  onChange: (e: any) => void
  onBlur?: (e: any) => void
  customFromGroupStyle?: string,
  label?: string,
  placeholder?: string
  icon?: React.ReactNode
  iconPosition?: 'left' | 'right'
  isIconClick?: () => void
  disabled?: boolean,
  handleKeyDown?: (event: any) => void,
  inputRef?: any,
  customIconStyle?: string,
  multiline?: boolean,
  asterisk?: boolean,
  customInputStyle?: Record<string, string>
  maxRows?: number
}

const CustomTextInput: React.FC<IProps> = ({ label, type, name, value, onChange, onBlur, placeholder,
   customFromGroupStyle, icon, disabled = false, isIconClick, handleKeyDown, inputRef,
    iconPosition = 'right', customIconStyle, multiline = false, asterisk = false, customInputStyle, maxRows }) => {
  return (
    <div className={`form-group ${customFromGroupStyle ? customFromGroupStyle : ''}`}>
      {label ? <label className="form-label fs-12">{label}{asterisk && <span className="asterisk">*</span>}</label> : ''}
      { !multiline ?
      <div className={`position-relative ${icon ? iconPosition === 'left' ? 'input-group-icon-left' : 'input-group-icon-right' : ''}`}>
        <input style={customInputStyle} ref={inputRef} type={type} name={name} value={value} onChange={onChange} placeholder={placeholder} className="form-control" disabled={disabled} onKeyDown={handleKeyDown} onBlur={onBlur}/>
        {icon &&
          <div className={`input-icon ${customIconStyle ? customIconStyle : ''} ${name === 'password' ? 'cursor-pointer' : ''}`} onClick={isIconClick}>
            {icon}
          </div>
        }
      </div>
      :
        <TextareaAutosize className="form-control form-textarea" maxRows={maxRows} value={value} onChange={onChange} placeholder={placeholder} disabled={disabled}/>
      }
    </div>
  )
};

export default CustomTextInput;